(function(module) {
    'use strict';

    function ViewUserCtrl($timeout, $scope, $state, User, Store, SubAccount, Includes, $stateParams) {

        this.getData = () => {
            // RESOLVE
            return Promise.all([this.getUser(), this.getSubAccounts()])
                .then(([user, subAccounts]) => {

                    _.set(user, 'isAccountAdmin', user.isAccountAdmin || false);

                     subAccounts.forEach( (subAccount)=> {
                        if(!user.permissions) {
                            user.permissions = {};
                        }
                         _.set(user, `permissions[${subAccount.id}]`, user.permissions[subAccount.id] || false);
                         _.set(user, 'permissions.main', user.permissions.main || false);
                    });
                     
                    this.user = Store.setSingleModelData('users', user.id, user);
                    this.subAccounts = Store.setMultiModelData('subAccounts', subAccounts);

                    if (!$scope.$$phase) {
                        $timeout(() => {
                            $scope.$apply();
                        });
                    }
                });
        };

        this.getUser = () => {
            return User
                .findById({
                    id: $stateParams.id,
                })
                .$promise;
        };

        this.getSubAccounts = () => {
            return SubAccount
                .find({ filter: Includes.subAccounts })
                .$promise;
        };

        this.$onInit = () => {
            this.currentUser = Store.getCurrentUser();
            this.account = Store.getCurrentAccount();
            this.getData();
        };

        this.save = () => {
            User
                .prototype$patchAttributes(
                    { id: this.user.id },
                    {
                        firstName: this.user.firstName,
                        lastName: this.user.lastName,
                        email: this.user.email.toLowerCase(),
                        permissions: this.user.permissions,
                        isAccountAdmin: this.user.isAccountAdmin,
                    },
                )
                .$promise
                .then((res) => {
                    return User.findById({
                        id: this.user.id,
                        filter: Includes.users,
                    }).$promise;
                })
                .then((user) => {
                    return Store.setSingleModelData('users', this.user.id, user);
                })
                .then(() => {
                    this.form.$setPristine();
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });
        };
    }

    module
        .config(($stateProvider) => {
            $stateProvider
                .state('root.users.view', {
                    url: '/:id',
                    data: {
                        pageTitle: 'USERS_VIEW.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<user-view-component />',
                        },
                    },
                    params: {
                        userId: { value: null },
                        user: { value: null },
                    },
                });

        })
        .component('userViewComponent', {
            controller: ViewUserCtrl,
            templateUrl: '/js/users/view-user/view-user.html',
        });

})(angular.module('rocket.components'));
